import React from "react";
import SearchRecord from "./SearchRecord";

export default function SearchRecords() {
  return <SearchRecord />;
}
